import { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  Table,
  Button,
  Modal,
} from "react-bootstrap";
import { GetAccessModalCustom } from "./getAccessModal";
import { cmsNavigation } from "../../../components/cmsNavigation";
import { motion, AnimatePresence, LayoutGroup } from "framer-motion";
import { FiGlobe, FiHome, FiSettings } from "react-icons/fi";
import styled from "styled-components";
import image from "../../../assets/images/mainLogo.png";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import {
  getCountryList,
  getCityList,
  getStateList,
} from "../../../services/system.js";
import {
  onBoardOrganization,
  onBoardRegion,
  onBoardSite,
} from "../../../services/authentication.js";
import {
  getPlanList,
  getSystemServices,
  customUserPlan,
  createPlan,
} from "../../../services/planServices";
import {
  callToast,
  showErrorMessages,
} from "../../../services/utilityFunctions";
import "../../../assets/css/onboarding.css";
import { getLocalStorageData } from "../../../services/axiosComponent";
import { DropdownIndicator } from "../../../views/dashboard/widget/tableWidget";
import ToggleSwitch from "../widget/toggleSwtich";
import { planColors } from "../../../services/constant";

const CustomPricingTable = ({
  organizationId,
  systemServices,

  userPlan,
} = {}) => {
  const navigate = useNavigate();
  const makePlans = () => {
    return userPlan.map((plan, index) => {
      return {
        ...plan,
        color: planColors[index],
        totalAmount: 0,
        planDiscount: 0,
        services: systemServices.map((feature) => ({
          ...feature,
          selected: false,
        })),
      };
    });
  };

  const [selectedServices, setSelectedServices] = useState(
    systemServices.map((feature) => ({
      selected: false,
    }))
  );

  const [makeCustomPlans, setMakeCustomPlans] = useState(makePlans());
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const buyNow = (plan) => {
    console.log("buy now", plan);
    console.log("selected plan", selectedPlan);
    console.log("make custom plans", makeCustomPlans);
    setShowModal(true);
  };

  const tableRowHeight = 48;
  const [createPlanLoading, setCreatePlanLoading] = useState(true);
  const [customPlanData, setCustomPlanData] = useState(null);

  const createCustomPlan = async (index) => {
    setCreatePlanLoading(true);
    const services = systemServices.reduce((acc, service, index) => {
      if (selectedServices[index].selected) {
        acc.push(service._ID);
      }
      return acc;
    }, []);
    const data = {
      services: services,
      maxUsers: makeCustomPlans[index]["MAX USERS"],
      validity: 12,
      validityIn: "MONTH",
      organizationId: organizationId,
    };
    console.log(data, "data");
    var res = await createPlan(data);
    console.log(res, "res");
    if (res.status === "success") {
      console.log("res", res.data);
      setCustomPlanData(res.data);
    } else {
      setShowModal(false);
      showErrorMessages({ data: res, navigate });
    }

    setCreatePlanLoading(false);
  };

  const calculateDiscountedPrice = (newPlans, planIndex) => {
    var amount = newPlans[planIndex].services.reduce((acc, current, index) => {
      if (selectedServices[index].selected) {
        return acc + current["_TOTAL AMOUNT"];
      }
      return acc;
    }, 0);
    var discountIn = newPlans[planIndex]["DISCOUNT IN"];
    var discount = newPlans[planIndex]["DISCOUNT"];
    if (discountIn === "Flat") {
      return (amount - discount) * newPlans[planIndex]["MAX USERS"];
    } else if (discountIn === "Percent") {
      return (
        (amount - (amount * discount) / 100) * newPlans[planIndex]["MAX USERS"]
      );
    }
  };
  const calculateOriginalPrice = (newPlans, planIndex) => {
    return (
      newPlans[planIndex].services.reduce((acc, current, index) => {
        return selectedServices[index].selected
          ? acc + current["_TOTAL AMOUNT"]
          : acc;
      }, 0) * newPlans[planIndex]["MAX USERS"]
    );
  };

  useEffect(() => {
    const newPlans = [...makeCustomPlans];
    newPlans.forEach((plan, index) => {
      plan.totalAmount = calculateDiscountedPrice(newPlans, index);
      plan.planDiscount = calculateOriginalPrice(newPlans, index);
    });
    setMakeCustomPlans(newPlans);

    return () => {};
  }, [selectedServices]);

  return (
    <>
      <div className="pricing-table shadow-lg rounded-3 overflow-hidden">
        <div className="d-flex position-relative">
          {/* Sticky First Column */}
          <div
            style={{
              width: 220,
              minWidth: 220,
              position: "sticky",
              left: 0,
              zIndex: 3,
              backgroundColor: "white",
              boxShadow: "4px 0 8px rgba(0, 0, 0, 0.05)",
            }}
          >
            <Table borderless className="mb-0">
              <thead>
                <tr>
                  <th
                    className="bg-light text-dark ps-4 fs-4"
                    style={{ height: 150 }}
                  >
                    Plans
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  style={{
                    height: tableRowHeight,
                  }}
                >
                  <td className="text-start py-2 bg-white small"></td>
                </tr>
                {systemServices.map((feature, index) => (
                  <tr
                    key={index}
                    style={{
                      height: tableRowHeight,
                      borderBottom: "1px solid #dee2e6",
                    }}
                  >
                    <td className="text-start py-2 bg-white small">
                      <input
                        key={feature._ID}
                        className="form-check-input me-2"
                        checked={selectedServices[index].selected}
                        onClick={() => {
                          var newSelectedServices = [...selectedServices];

                          newSelectedServices[index].selected =
                            !newSelectedServices[index].selected;
                          setSelectedServices(newSelectedServices);
                        }}
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      ></input>
                      {feature.NAME}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Scrollable Columns */}
          <div className="flex-grow-1 overflow-auto">
            <Table borderless className="mb-0">
              <thead>
                <tr>
                  {makeCustomPlans.map((plan, index) => (
                    <th
                      key={plan._ID}
                      className="text-white position-relative py-3"
                      style={{
                        height: 150,
                        maxWidth: 300,
                        background: `linear-gradient(135deg, ${planColors[index]}, ${planColors[index]}90)`,
                        minWidth: 300,
                      }}
                    >
                      <div className="d-flex flex-column align-items-center gap-0">
                        <div className="users-display mb-0 d-flex align-items-center justify-content-center gap-2">
                          <div className="users-icon-wrapper">
                            <motion.div
                              className="user-icon"
                              initial={{ scale: 0, opacity: 0 }}
                              animate={{ scale: 1, opacity: 1 }}
                              transition={{ duration: 0.3 }}
                            >
                              <svg
                                width="40"
                                height="40"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                              >
                                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                              </svg>
                            </motion.div>
                          </div>
                          <h4 className="mb-0 user-count d-flex align-items-center gap-1 ">
                            <span className="user-number">
                              {plan["MAX USERS"]}
                            </span>
                          </h4>
                        </div>
                        {plan["totalAmount"] != 0 ? (
                          <div className="price-content mb-5 mt-0 pt-0">
                            <span className="discount-highlight">
                              {plan["DISCOUNT IN"] === "Percent" ? (
                                <>{plan["DISCOUNT"]}% OFF</>
                              ) : (
                                <>
                                  {plan["_CURRENCY SYMBOL"]}
                                  {plan["DISCOUNT"]} OFF
                                </>
                              )}
                            </span>
                          </div>
                        ) : null}
                        <div
                          className="price-bubble"
                          style={{
                            background: planColors[index],
                            width: "100px",
                            height: "100px",
                            marginTop: "0.5rem",
                          }}
                        >
                          {plan["totalAmount"] == 0 ? (
                            <div className="price-content discount-badge">
                              <span className="discount-highlight">
                                {plan["DISCOUNT IN"] === "Percent" ? (
                                  <>{plan["DISCOUNT"]}% OFF</>
                                ) : (
                                  <>
                                    {plan["_CURRENCY SYMBOL"]}
                                    {plan["DISCOUNT"]} OFF
                                  </>
                                )}
                              </span>
                            </div>
                          ) : (
                            <div className="price-content">
                              <div className="pricing-stack">
                                {plan["planDiscount"] && (
                                  <span className="original-price">
                                    {plan["_CURRENCY SYMBOL"]}
                                    {plan["planDiscount"].toLocaleString(
                                      "en-US"
                                    )}
                                  </span>
                                )}
                                <span
                                  className="current-price price-badge"
                                  style={{}}
                                >
                                  {plan["_CURRENCY SYMBOL"]}
                                  {plan["totalAmount"].toLocaleString("en-US")}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                <tr>
                  {makeCustomPlans.map((plan, index) => (
                    <td
                      key={`${index}`}
                      className="py-2"
                      style={{
                        height: tableRowHeight,
                        backgroundColor:
                          index % 2 === 0 ? "#FFFFFF" : "#F8F9FC",
                        minWidth: 200,
                      }}
                    ></td>
                  ))}
                </tr>
                {systemServices.map((feature, planIndex) => (
                  <tr key={planIndex} style={{ height: 48 }}>
                    {makeCustomPlans.map((plan, serviceIndex) => (
                      <td
                        key={serviceIndex}
                        className="py-2"
                        style={{
                          height: tableRowHeight,
                          minWidth: 200,
                          backgroundColor:
                            serviceIndex % 2 === 0 ? "#FFFFFF" : "#F8F9FC",
                          borderBottom: "1px solid #dee2e6",
                        }}
                      >
                        {selectedServices[planIndex].selected ? (
                          <FaCheckCircle className="text-success fs-6" />
                        ) : (
                          <FaTimesCircle className="text-danger fs-6" />
                        )}
                        {/* <input
                          key={serviceIndex}
                          className="form-check-input"
                          checked={checkIfSrevicesExist(
                            plan["services"],
                            feature
                          )}
                          onClick={() =>
                            selectOrDeselectService(serviceIndex, planIndex)
                          }
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        ></input> */}
                      </td>
                    ))}
                  </tr>
                ))}

                <tr style={{ height: 80 }}>
                  {makeCustomPlans.map((plan, index) => (
                    <td
                      key={`${index}`}
                      className="py-2"
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#FFFFFF" : "#F8F9FC",
                        minWidth: 200,
                      }}
                    >
                      <Button
                        onClick={() => {
                          createCustomPlan(index);
                          setSelectedPlan(index);
                          buyNow(plan);
                        }}
                        disabled={plan["totalAmount"] == 0}
                        style={{
                          backgroundColor: planColors[index],
                          borderRadius: "50px",

                          padding: "6px 20px",
                          fontSize: "0.875rem",
                          border: "none",
                        }}
                        className="hover-scale"
                      >
                        Buy Now
                      </Button>
                    </td>
                  ))}
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      <GetAccessModalCustom
        showModal={showModal}
        setShowModal={setShowModal}
        createPlanLoading={createPlanLoading}
        systemServices={systemServices}
        selectedPlan={selectedPlan}
        selectedServices={selectedServices}
        makeCustomPlans={makeCustomPlans}
        customPlanData={customPlanData}
      />
      <style></style>

      <style>{`
  .modern-pricing-modal {
    --modal-radius: 1.5rem;
    --feature-icon-size: 2.5rem;
    --price-card-width: 320px;
    font-family: 'Helvetica Neue', Arial, sans-serif;
  }

  /* Override default modal-body and modal-content backgrounds */
  .modern-pricing-modal .modal-body,
  .modern-pricing-modal .modal-content {
    background: transparent !important;
    border: none;
    padding: 0;
  }

  .modal-content-wrapper {
    border-radius: var(--modal-radius);
    overflow: hidden;
    position: relative;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .modal-grid-container {
    display: grid;
    grid-template-columns: 1fr var(--price-card-width);
    min-height: 600px;
  }

  .features-section {
    padding: 3rem;
    position: relative;
    overflow-y: auto;
    max-height: 80vh;
  }

  .feature-content {
    padding: 1rem 0;
  }

  .features-list {
    display: grid;
    gap: 1.5rem;
    grid-template-columns: repeat(2, 1fr);
  }

  .feature-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.75rem;
    padding: 1rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 1rem;
    transition: all 0.3s ease;
  }

  .feature-item:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
  }

  .feature-icon {
    width: var(--feature-icon-size);
    height: var(--feature-icon-size);
    flex-shrink: 0;
    display: grid;
    place-items: center;
    background: #ffffff;
    border-radius: 0.75rem;
  }

  .feature-text h4 {
    margin-bottom: 0.5rem;
    font-size: 1rem;
    color: #fff;
  }

  .feature-text p {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.9);
  }

  .pricing-card {
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(10px);
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    border-radius: var(--modal-radius);
  }

  .price-content {
    position: relative;
    z-index: 2;
  }

  .price-header {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .price-badge {
    display: inline-block;
    background: #B2ACAC69;
    backdrop-filter: blur(4px);
    color: #fff;
    padding: 8px 16px;
    border-radius: 24px;
    font-weight: 600;
    margin-bottom: 1rem;
    font-size: 0.9rem;
  }

  .price-amount {
    font-size: 3rem;
    font-weight: 800;
    color: #fff;
    line-height: 1;
    margin: 0.5rem 0;
  }

  .currency {
    font-size: 1.2rem;
    vertical-align: super;
  }

  .price-description {
    font-size: 0.8rem;
    opacity: 0.9;
    color: #fff;
  }

  .price-benefits {
    margin-bottom: 1.5rem;
  }

  .benefit-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem;
    color: #fff;
    margin: 0.5rem 0;
    font-size: 0.85rem;
  }

  .purchase-button {
    width: 100%;
    padding: 0.75rem;
    border: none;
    background: #fff;
    color: ${planColors[selectedPlan]};
    border-radius: 1rem;
    font-weight: 700;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .purchase-button:hover {
    background: rgba(255, 255, 255, 0.9);
  }

  .discount-badge {
    padding: 8px 16px;
    border-radius: 24px;
    background: #B2ACAC69;
    backdrop-filter: blur(4px);
  }

  .discount-highlight {
    font-size: 1.1rem;
    font-weight: 700;
    letter-spacing: -0.5px;
    background: linear-gradient(45deg, #FFFFFCFF, #FBFBFBFF);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  .pricing-stack {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .original-price {
    font-size: 1rem;
    text-decoration: line-through;
    opacity: 0.9;
    margin-bottom: -2px;
    color: #FFFFFFFF;
  }

  .current-price {
    font-size: 1.55rem;
    font-weight: 600;
    line-height: 1;
    color: white;
  }

  .billing-period {
    font-size: 0.8rem;
    font-weight: 400;
    opacity: 0.8;
  }

  .plan-description {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Price bubble styles */
  .price-bubble {
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
  }

  .price-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0.25rem;
  }

  /* Hover effects for discount highlight */
  .price-bubble:hover .discount-highlight {
    animation: discount-pulse 1s ease-in-out infinite;
  }

  @keyframes discount-pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }

  .pricing-table {
    max-width: 100vw;
  }

  @media (max-width: 768px) {
    .price-bubble {
      width: 70px !important;
      height: 70px !important;
    }
    
    .current-price {
      font-size: 1.1rem;
    }
    
    th, td {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 576px) {
    .price-bubble {
      width: 60px !important;
      height: 60px !important;
    }
    
    .original-price {
      font-size: 0.65rem;
    }
    
    .current-price {
      font-size: 1rem;
    }
  }
`}</style>
    </>
  );
};
export default CustomPricingTable;
